<!--
 - Author : 003.
 - Date   : 2019/5/31.
 - File   : index.第一食堂
 -->

<template>
  <div class="shi-t-wrap">
    <!-- 吉大返回按钮 -->
    <div v-if="isJida" class="btn-back" title="返回首页" @click="$router.push('/')">
      <i class="el-icon-back"></i>
    </div>

    <!--左侧内容-->
    <div class="left-pos">
      <!--今日陪餐领导-->
      <peicLeader :state="manageControl.e001" :total="supplierNum"></peicLeader>
      <!--左侧中间各模块-->
      <leftCenter :state="manageControl.e002" :total="supplierNum"></leftCenter>
      <!--总能耗-->
      <energy v-if="manageControl.e002===1 && !sensorHiding" :state="manageControl.e002"></energy>
      <!--环境指标-->
      <sensor v-if="sensorHiding"></sensor>
    </div>
    <div class="content">
      <excep-handle-n1 class="msg-excep-handle"
                       v-if="msgBoxSingleExVisible"
                       :isScroll="true"
                       :showChuRegion="false"
                       :current="msgBoxSingle"
                       :disabled="true"
                       :exceptType="exceptType"
                       @cancelFn="msgBoxSingleExVisible=false"
                       @closeEC="msgBoxSingleExVisible=false"
      ></excep-handle-n1>
      <!-- 跳转到车载摄像头 -->
      <!--<div style="color: #fff;padding: 4px 8px;border-radius:6px;cursor: pointer;position: absolute;left: 0px;top:20px; box-shadow: 0px 0px 4px 4px #f5f5f5;" @click="toOnBoardPage">-->
        <!--车载摄像头-->
      <!--</div>-->
      <!--摄像头点位-->
      <doteMap></doteMap>
      <!--异常信息-->
      <ycArea :state="manageControl.e004===1" :floorId="exceptionQueryFloorId" :contracorId="exceptionQueryContractorId"></ycArea>
    </div>
    <div :style="{display: showRight?'none':'block'}" class="food-check" @click="showStore" v-if="hideTesting">食品快检</div>
    <transition name="right-list-ct">
      <div class="right-pos" v-if="manageControl.e004===1">
        <div class="right-wrap" v-if="showRight">
          <div class="tag-show-hide" @click="showRight = false"></div>
          <h2>食品快检记录</h2>
          <!--<todayRK></todayRK>-->
          <consumeTotal></consumeTotal>
        </div>
      </div>
    </transition>
    <video class="video" src="../../static/video/diyishitang.ogg" muted autoplay loop>
    </video>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import peicLeader from '@/components/shitang/peicLeader'
  import energy from '@/components/shitang/energy'
  import sensor from '@/components/shitang/sensor'
  import doteMap from '@/components/shitang/doteMap'
  import ycArea from '@/components/shitang/ycArea'
  // import todayRK from '@/components/shitang/todayRK'
  import consumeTotal from '@/components/shitang/consumeTotal'
  import leftCenter from '@/components/shitang/leftInfo'

  export default {
    components: {
      peicLeader,
      energy,
      sensor,
      doteMap,
      ycArea,
      // todayRK,
      consumeTotal,
      leftCenter
    },
    data () {
      return {
        msgBoxSingleExVisible: false,
        msgBoxSingle: {},
        showRight: false,
        hideTesting: true, // 是否显示农药检测
        sensorHiding:false, //是否展示环境指标
        imgPic: '',
        imgUrl: this.$store.getters.fileApi,
        defaultImg: require('../assets/images/avatar.jpg'),
        jdObj: {},
        deptId: this.$route.query.deptId,
        deptName: this.$route.query.deptName,
        manageControl: {},
        supplierNum: 0,
        viewObj: window.localStorage.getItem('viewObj'),
        videoLoading: false,
        exceptType: '', // text：文本，vedio：视频+文本，image：图片+文本
        exceptionQueryFloorId: '', // 异常查询使用的楼层ID
        exceptionQueryContractorId: '', // 异常查询使用的运营商ID
      }
    },
    computed: {
      ...mapGetters({  //这里的...不是省略号了,是对象扩展符
        isJida: 'isJida'
      })
    },
    mounted () {
      this.onWebsocketMsg()
      this.getDeptList()
      this.contraListGet(this.deptId)
      // 邮校食堂不展示食品快检
      if(this.deptId === 'D18CA078186694D1D84AE02353709E50D') {
        this.hideTesting = false
      }
      else {
        this.hideTesting = true
      }
      // 教职工食堂展示环境指标
      if(this.deptId === 'DE17518505BE649BC8451826F40FAF9CC') {
        this.sensorHiding = true
      }
      else {
        this.sensorHiding = false
      }
    },
    methods: {
      /**
       * 获取websocket推送信息
       * @author wanghongling
       * @createTime 2017-07-18
       */
      onWebsocketMsg () {
        window.webSocket.onmessage = e => {
          if (e.data === 'heartbeat') return
          let data = JSON.parse(e.data)
          switch (data.type) {
            case 'szsa-01':
              this.getExceptionNewList()
              break
            case 'szsa-06':
            case 'szsa-07':
            case 'szsa-11':
              window.getYiChangMsg(data)
              window.getYCTotal()
              break
            case 'szsa-02':
              window.getDeviceStatus(data)
              break
            case 'szsa-03':
              window.getTempHum(data)
              break
            case 'szsa-04':
              if (this.manageControl.e002 === 1) {
                window.getEnergy(data)
              }
              break
            case 'szsa-05':
              if (this.manageControl.e002 === 1) {
                window.getWater(data)
              }
              break
            case 'szsa-21':
              window.getAirQuality(data)
              break
            case 'szsa-22':
              window.getOzone(data)
              break
            case 'szsa-08':
              if (this.manageControl.e004 === 1) {
                window.getNewNC(data)
              }
              break
            // case 'szsa-0801':
            //   if (this.manageControl.e004 === 1) {
            //     window.getNCCB(data)
            //   }
            //   break
            // case 'szsa-0802':
            //   if (this.manageControl.e004 === 1) {
            //     window.getNCCount(data)
            //   }
            //   break
            case 'szsa-09':
            case 'szsa-10':
              if (this.manageControl.e002 === 1) {
                window.getWaterElec()
              }
              break
            case 'szsa-12':
              window.getYiChangMsgTotal()
              break
            case 'szsa-13':
              window.getYiChangMsgTotal()
              window.getPersonWebsock()
              break
            case 'szsa-15':
              window.getCameraState(data)
              break
            case 'szsa-17':
            case 'szsa-18':
              window.getPersonWebsock()
              break
            default:
              break
          }
        }
      },
      /**
       * @author wanghongling
       * @createTime 2019/06/19
       * @description 获取最新异常信息
       */
      getExceptionNewList () {
        let pageSize = 17
        let param = {
          departmentId: this.deptId,
          page: 1,
          pageSize: pageSize
        }
        this.$request.exceptionNewDeptListGet(param).then(response => {
          if (!this.$utils.isEmptyObject(response) ) {

            let exceptionId = response[0].exceptionId
            this.exceptType = ''
            this.msgBoxSingleExVisible = false
            this.$request.regionExceptionInfoGet({exceptionId}).then(res=>{
              this.msgBoxSingle = res
              if(res.fileList && res.fileList.length>0) {
                this.msgBoxSingle.exceptionImageUrl = this.imgUrl+res.fileList[0]
              }
              this.msgBoxSingleExVisible = true
              /*setTimeout(()=>{
                this.msgBoxSingleExVisible = false
              },5000)*/
            }).catch(ex => {
              console.error(ex)
            })
          }
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:显示仓库区
       * @author wanghongling
       * @createDate 2019/11/8
       */
      showStore () {
        this.showRight = !this.showRight
      },
      /**
       * @Description:食堂管理获取食堂列表
       * e001 (integer, optional): 今日陪餐领导(1-开启 0-关闭) ,
       * e002 (integer, optional): 水、电功耗检测(1-开启 0-关闭) ,
       * e003 (integer, optional): 周边餐饮(1-开启 0-关闭) ,
       * e004 (integer, optional): 出入库相关统计(1-开启 0-关闭)
       * @author wanghongling
       * @createDate 2019/12/3
       */
      getDeptList () {
        let params = {
          departmentId: this.deptId
        }
        this.$request.deptPcPowerGet(params).then(res => {
          console.log('食堂管理获取食堂列表权限', this.manageControl, res)
          this.manageControl = res
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * @Description:
       * @author wanghongling
       * @createDate 2019/12/6
      */
      contraListGet (deptId) {
        this.$request.constramanageContraListGet({departmentId: deptId}).then(res => {
          console.log('根据食堂ID，获取供应商列表', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.supplierNum = res.list.length
          } else {
            this.supplierNum = 0
          }
        }).catch(e => {
          console.error(e)
        })
      },
      toOnBoardPage() {
        window.open('https://175.42.30.45:1443/portal/ui/login')
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../assets/less/color';

  .shi-t-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .left-pos {
      position: absolute;
      left: 15px;
      top: 106px;
      z-index: 4;

      .layer-wrap {
        margin-top: 11px;
      }
    }

    .content {
      position: absolute;
      left: 480px;
      top: 100px;
      z-index: 1;

      .yc-area-wrap {
        position: relative;
        left: 40px;
        top: -20px;
      }
      .msg-excep-handle{
        position: absolute;
        left: 27%;
        top: 13%;
      }
    }

    .right-pos {
      position: fixed;
      right: 0;
      top: 50px;
      z-index: 4;

      .right-wrap {
        width: 529px;
        height: 1028px;
        padding: 50px 0 40px 102px;
        background: url("../assets/images/shitang/right_bg.png") right top no-repeat;

        .tag-show-hide {
          cursor: pointer;
          position: absolute;
          top: 370px;
          left: 58px;
          width: 23px;
          height: 358px;
          background: url("../assets/images/shitang/btn-hide.png") right top no-repeat;;
        }

        h2 {
          padding: 8px;
          font-weight: bold;
          font-size: 27px;
          text-align: left;
          color: #fff;
        }

        .health {
          padding: 18px 15px;
          margin-top: 5px;
          border-top: 2px solid rgba(32, 138, 139, .5);

          ul {
            display: flex;

            li {
              flex: 1;
              display: flex;
              /*justify-content: center;*/
              align-items: center;

              img {
                width: 65px;
                height: 65px;
                border-radius: 50%;
                object-fit: cover;
                background: #fff;
              }

              .he-detail {
                padding-left: 12px;

                p {
                  color: #0aaade;
                  font-size: 16px;
                }

                p:last-child {
                  color: @lightBlue;
                  font-size: 14px;
                  margin-top: 6px;
                }
              }
            }
          }
        }
      }
    }

    .right-list-ct-enter-active {
      transition: all 0.5s linear;
    }

    .right-list-ct-leave-active {
      transition: all 0.5s linear;
    }

    .right-list-ct-enter, .right-list-ct-leave-to
      /* .slide-fade-leave-active for below version 2.1.8 */ {
      transform: translateX(390px);
      opacity: 0;
    }
    .food-check{
      position: fixed;
      right: 0;
      top: 110px;
      font-size: 16px;
      z-index: 99999;
      background: #01212e;
      width: 40px;
      color: #fff;
      padding: 10px 5px;
      text-align: center;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      cursor: pointer;
      &:hover{
        opacity: 0.8;
      }
    }
    .btn-back {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 470px;
      top: 116px;
      z-index: 4;
      width: 30px;
      height: 30px;
      border-radius: 10px;
      background: rgba(0,3,6,.7);
      cursor: pointer;

      .el-icon-back {
        color: #00aaf1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/shitang.vue